module.exports = __webpack_public_path__ + "img/cwi_logo.b2f828b7.png";